import { useTheme } from "@mui/material";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-react";
import remarkGfm from "remark-gfm";

import { reactMarkdownComp } from "../../../../../Constants/reactMarkdownComp";
import {
  Container,
  ReasoningContentContainer,
  ReasoningSideLineContainer,
  StyledReasoningSideLine,
} from "./style";

type ReasoningDisplayerProps = {
  reasoning: any;
  streaming?: boolean;
};

const ReasoningDisplayer = ({
  reasoning,
  streaming = false,
}: ReasoningDisplayerProps) => {
  const { palette } = useTheme();

  return (
    <Container>
      <ReasoningSideLineContainer>
        <StyledReasoningSideLine />
      </ReasoningSideLineContainer>
      <ReasoningContentContainer>
        <ReactMarkdown
          children={reasoning}
          remarkPlugins={[remarkGfm]}
          rehypePlugins={[rehypeRaw] as any}
          components={reactMarkdownComp}
        />
        {/**
         * <StyledTypography variant="caption">{reasoning}</StyledTypography>
         */}
      </ReasoningContentContainer>
    </Container>
  );
};

export default ReasoningDisplayer;
